<template>
  <div>
      <div class="get-started-container">
        <h1>My Details</h1>
        <el-form ref="form" label-position="top">
          <el-form-item label="Date of Birth">
            <el-date-picker v-model="user.dob" type="date" placeholder="Pick a day" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="What is your fitness experience to this point?">
            <el-input placeholder="" v-model="user.fitnessExperience" type="textarea" />
          </el-form-item>
          <el-form-item label="Do you train at a gym? If so, which?">
            <el-input placeholder="" v-model="user.trainAtGym" type="textarea" />
          </el-form-item>
          <el-form-item label="What is your story? Tell us about you.">
            <el-input type="textarea" v-model="user.story" placeholder="" />
          </el-form-item>
          <el-form-item label="What has motivated you to take on the WZA Transformation Challenge?">
            <el-input placeholder="" v-model="user.whyMove" type="textarea" />
          </el-form-item>
          <el-form-item label="List your goals.">
            <el-input placeholder="" v-model="user.goal" type="textarea" />
          </el-form-item>
          <el-form-item label="Which program do you wish to follow?">
            <el-select placeholder="Select" v-model="user.programs" multiple>
              <el-option
                v-for="item in programs"
                :key="item.id"
                :label="item.attributes.title"
                :value="item.attributes.title">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="If WZA @ Home - What equipment do you have access to?">
            <el-select placeholder="Select" v-model="user.equipments" multiple width="100%">
              <el-option
                v-for="item in equipments"
                :key="item.id"
                :label="item.attributes.title"
                :value="item.attributes.title">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="get-started-btn" @click="onSubmit">Save</el-button>
          </el-form-item>
        </el-form>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  data () {
    return {
      dob: null,
      user: {
        dob: null,
        fitnessExperience: '',
        trainAtGym: '',
        story: '',
        whyMove: '',
        goal: '',
        programs: [],
        equipments: []
      },
      programs: [],
      equipments: []
    }
  },
  mounted: function(){
    var user = Parse.User.current();
    if(!user){
       this.$router.push('/login');
       return
    }
    this.user = {
      ...this.user,
      ...user.attributes,
    }
    if(user.attributes.dobYear && user.attributes.dobMonth && user.attributes.dobDay){
      this.dob = moment(user.attributes.dobYear + ' ' + user.attributes.dobMonth + ' ' + user.attributes.dobDay);
    }
    var postQuery = new Parse.Query("Programs");
    postQuery.find().then(results => {
      this.programs = results;
    })
    .catch(function(err) {
      console.log(err);
    });
    var equipmentsQuery = new Parse.Query("Equipments");
    equipmentsQuery.find().then(results => {
      this.equipments = results;
    })
    .catch(function(err) {
      console.log(err);
    });
  },
  methods:{
    onSubmit:function(){
      var user = Parse.User.current();
      user.set('dob', this.user.dob);
      user.set('fitnessExperience', this.user.fitnessExperience);
      user.set('trainAtGym', this.user.trainAtGym);
      user.set('story', this.user.story);
      user.set('whyMove', this.user.whyMove);
      user.set('goal', this.user.goal);
      user.set('programs', this.user.programs);
      user.set('equipments', this.user.equipments);
      user.save().then(res => {
        this.$message({
          type: 'success',
          message: 'Your details were changed!'
        });
      }).catch(err => {
        this.$message({
          type: 'error',
          message: 'Something went wrong, please try again'
        });
      })
    }
  }
}
</script>

<style>
.get-started-container{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  text-align: left;
}
.get-started-container form {
  max-width: 500px;
  margin:30px auto;
}
.get-started-container h1 {
  width: 100%;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
  font-family: prohibition;
  text-align: center;
  font-size: 30px;
  box-sizing: border-box;
}
.get-started-container .el_select {
  width: 100%;
}
.get-started-container a{
  color: #d7347d;
}
.get-started-container p{
  text-align: center;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.el-input-group__append{
  width: 40px;
}
.get-started-btn {
  width: 100%;
}
.get-started-container .el-form--label-top .el-form-item__label{
  font-size: 14px;
}
</style>